import React from 'react'
import classNames from 'classnames'

const Col = ({
  children,
  full = true,
  visible = true,
  xs,
  sm,
  md,
  lg,
  xl,
  className
}) => {
  const colSpans = {
    1: 'col-span-1',
    2: 'col-span-2',
    3: 'col-span-3',
    4: 'col-span-4',
    5: 'col-span-5',
    6: 'col-span-6',
    7: 'col-span-7',
    8: 'col-span-8',
    9: 'col-span-9',
    10: 'col-span-10',
    11: 'col-span-11',
    12: 'col-span-12'
  }

  const colClass = classNames(className, {
    'col-span-12': full && !xs,
    [colSpans[xs]]: xs && colSpans[xs],
    [`sm:${colSpans[sm]}`]: sm && colSpans[sm],
    [`md:${colSpans[md]}`]: md && colSpans[md],
    [`lg:${colSpans[lg]}`]: lg && colSpans[lg],
    [`xl:${colSpans[xl]}`]: xl && colSpans[xl]
  })

  if (!visible) {
    return null
  }

  return (
    <div className={colClass}>
      {children}
    </div>
  )
}

export default Col
